import { useEffect } from "react";
import classNames from "classnames";
import { Typography } from "components/atoms";
import { CloseIcon, PauseIcon, PlayIcon } from "components/atoms/Icon";
import {
  changeHours,
  changeMinutes,
  changeSeconds,
  decrementHours,
  decrementMinutes,
  decrementSeconds,
  handleGlobalModalClose,
  handleGlobalTimePause,
  handleGlobalTimeSubmit,
  incrementHours,
  incrementMinutes,
  incrementMinutesByAmount,
  incrementSeconds,
} from "state/reducers/studyTimerSlice";
import { counter } from "worker/timerWorker";
import { useAppDispatch } from "hooks";
import "./index.scss";
import { persistor } from "state/store";
import { useNavigate, useLocation } from "react-router-dom";

interface IProps {
  theme: "light" | "dark";
  hours: number;
  minutes: number;
  seconds: number;
  isTimePause: boolean;
  isTimeSubmit: boolean;
}

export const TimerSubmitPopUp = ({
  theme,
  hours,
  minutes,
  seconds,
  isTimePause,
  isTimeSubmit,
}: IProps) => {
  const formatTime = (value: number) => {
    return value.toString().padStart(2, "0");
  };
  const dispatch: any = useAppDispatch();
  const location = useLocation();

  counter.onmessage = (e: MessageEvent) => {
    dispatch(changeMinutes(e.data.minutes));
    dispatch(changeSeconds(e.data.seconds));
    dispatch(changeHours(e.data.hours));
  };

  const handleTimePause = () => {
    if (!isTimePause) {
      dispatch(handleGlobalTimePause(true));
      counter?.postMessage({
        action: "pause",
      });
    } else {
      dispatch(handleGlobalTimePause(false));
      counter?.postMessage({
        action: "start",
        seconds: seconds,
        minutes: minutes,
        hours: hours,
      });
    }
  };

  const handelTimerModalClose = () => {
    dispatch(handleGlobalModalClose(false));
    dispatch(changeSeconds(0));
    dispatch(changeMinutes(0));
    dispatch(changeHours(0));
    dispatch(handleGlobalTimeSubmit(false));
    dispatch(handleGlobalTimePause(false));
    counter?.postMessage({
      action: "pause",
    });
  };

  const handleTimerIncrease = (minutesCount: number) => {
    if (minutes + minutesCount === 60) {
      dispatch(changeMinutes(0));
      dispatch(changeHours(hours + 1));

      if (!isTimePause) {
        counter?.postMessage({
          action: "start",
          seconds: seconds,
          minutes: 0,
          hours: hours + 1,
        });
      }
    } else if (minutes + minutesCount > 60) {
      dispatch(changeMinutes(minutes + minutesCount - 60));
      dispatch(changeHours(hours + 1));

      if (!isTimePause) {
        counter?.postMessage({
          action: "start",
          seconds: seconds,
          minutes: minutes + minutesCount - 60,
          hours: hours + 1,
        });
      }
    } else {
      dispatch(changeMinutes(minutes + minutesCount));

      if (!isTimePause) {
        counter?.postMessage({
          action: "start",
          seconds: seconds,
          minutes: minutes + minutesCount,
          hours: hours,
        });
      }
    }
  };

  useEffect(() => {
    if (!isTimePause && isTimeSubmit) {
      counter?.postMessage({
        action: "start",
        seconds: seconds,
        minutes: minutes,
        hours: hours,
      });
    }
  }, []);

  return (
    <div className="timer-play-popup">
      <div className="timer-play-modal-header">
        <div className="timer-play-modal-header-typography">
          <div className={classNames("title-typography-wrapper")}>
            <Typography
              label="Study Timer"
              variant="h6Medium"
              styles="timer-play-modal-header-typography-custom-style"
            />
          </div>
        </div>
        <div
          className="timer-play-modal-header-close-icon"
          onClick={handelTimerModalClose}
        >
          <CloseIcon theme={theme} />
        </div>
      </div>
      <div className="timer-play-modal-body">
        <div className="content-section">
          <div className="timing-section">
            <Typography label={`${formatTime(hours)}`} variant="h2Med" />
            <Typography label={`:`} variant="h2Med" />
            <Typography label={`${formatTime(minutes)}`} variant="h2Med" />
            <Typography label={`:`} variant="h2Med" />
            <Typography label={`${formatTime(seconds)}`} variant="h2Med" />
          </div>
          <div className="minutes-section">
            <div className="minutes-section-wrapper">
              <div
                className="first-minutes-section"
                onClick={() => handleTimerIncrease(1)}
              >
                <Typography
                  label="+1m"
                  variant="h9Medium"
                  styles="first-minutes-section-custom-typography-style"
                />
              </div>
              <div
                className="second-minutes-section"
                onClick={() => handleTimerIncrease(5)}
              >
                <Typography
                  label="+5m"
                  variant="h9Medium"
                  styles="first-minutes-section-custom-typography-style"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="pause-play-section" onClick={handleTimePause}>
          {isTimePause ? (
            <PlayIcon theme={theme} />
          ) : (
            <PauseIcon theme={theme} />
          )}
        </div>
      </div>
    </div>
  );
};
